var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "currentColor",
    clipRule: "evenodd",
    d: "M12 19C12 15.1 15.1 12 19 12C19.7 12 20.4 12.1 21 12.3V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H12.3C12.1 20.4 12 19.7 12 19ZM5 8V5H19V8H5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.304 18.9781C20.6275 19.6547 19.6472 19.8342 18.8049 19.5373L16.4508 21.8914C16.3128 22.0295 16.0987 22.0295 15.9607 21.8914L14.9942 20.9249C14.8561 20.7868 14.8561 20.5728 14.9942 20.4348L17.3483 18.0806C17.0514 17.2384 17.2309 16.2581 17.9075 15.5816C18.6738 14.8153 19.8267 14.6841 20.7379 15.1742L19.1156 16.7966L20.089 17.77L21.7114 16.1476C22.2015 17.052 22.0703 18.2118 21.304 18.9781Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.3b748048ab85d60437884b8175ef5505.svg";
export { ForwardRef as ReactComponent };